module.exports = __webpack_public_path__ + "static/img/manual-15.de98a5e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-15.png
// module id = 0hZI
// module chunks = 4